import { isIOS } from 'react-device-detect'
import { overlayBreakpointMap } from 'theme/overlay'

export const sanitize = (input) => {
  const doc = new DOMParser().parseFromString(input, 'text/html')
  for (const elm of doc.querySelectorAll('*')) {
    for (const attrib of elm.attributes) {
      if (attrib.name.startsWith('on')) {
        elm.removeAttribute(attrib.name)
      }
    }
  }
  return doc.body.innerHTML
}

export const toggleHtmlScrollable = (scrollable: boolean) => {
  if (typeof window == 'undefined') return

  if (!scrollable) {
    window.document.body.style.overflow = 'hidden'
    window.document.documentElement.style.overflow = 'hidden'
    // window.document.body.style.overflow = 'hidden'
    // window.document.body.style.position = 'fixed'
  } else {
    window.document.body.style.overflow = 'auto'
    window.document.documentElement.style.overflow = 'auto'
    // window.document.body.style.overflow = 'unset'
    // window.document.body.style.position = 'relative'
  }
}

export const detectHtmlTag = (input: string, tagName: string, attributes: string[] = []) => {
  const tag = tagName.toLowerCase()

  const attrPattern = attributes
    .map((attr) => {
      const [key, value] = attr.split('=')
      // const realKey = key === 'className' ? 'class' : key
      const val = value.replace(/['"]/g, '')
      return `${key}\\s*=\\s*['"]${val}['"]`
    })
    .join('\\s+')

  const pattern = attrPattern ? new RegExp(`<${tag}\\s+${attrPattern}[^>]*>`, 'i') : new RegExp(`<${tag}[^>]*>`, 'i')

  // console.log(detectHtmlTag(html, "a")); // true
  // console.log(detectHtmlTag(html, "a", ["className='hehe'"])); // true
  // console.log(detectHtmlTag(html, "a", ["className='hehe'", "href='/klelvin'"])); // true
  // console.log(detectHtmlTag(html, "a", ["className='nope'"])); // false

  return pattern.test(input)
}

const APP_CONTENT_ID = 'app-content'
const HIDE_SCROLLBAR_CLASS = 'hide-scrollbar'

export const toggleAppContentScrollbar = (hide: boolean) => {
  if (typeof window == 'undefined') return

  const appContent = document.getElementById(APP_CONTENT_ID)

  if (appContent && window.innerWidth >= overlayBreakpointMap.sidebarOverlay && !isIOS) {
    if (hide) {
      appContent.classList.add(HIDE_SCROLLBAR_CLASS)
    } else {
      appContent.classList.remove(HIDE_SCROLLBAR_CLASS)
    }
  }
}
